<template>


  <v-card
    class="mx-auto opacity-100"
    max-width="500"
  >
    <v-container fluid>
      <v-row dense>
        <v-col
          cols=12
        >
          <v-card>
            <v-img
              src="ttps://cdn.vuetifyjs.com/images/cards/house.jpg"
              class="align-top"
              gradient="to bottom, rgba(50, 92, 168,.5),rgba(174, 38, 201,.3)"
              :height="infoHeight"
              
            >
              <v-card-title v-text="indicatorTitle"></v-card-title>
              <v-card-subtitle v-text="indicatorFunction"></v-card-subtitle>
              <v-card-text v-text="indicatorInfoText"></v-card-text> 
              <v-card-text v-text="indicatorAdditionalInfoText"></v-card-text> 
           
            </v-img>
              <button @click="showingFullText = !showingFullText" class="font-italic text-caption text-grey">
                  Read {{ showingFullText ? "Less" : "More" }}
              </button> 
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols=11
        >
         <!-- <SOSPolarChart :polarData="chartData" style="max-height: 500px;"/> -->
         <v-card>
            <v-img
              src="ttps://cdn.vuetifyjs.com/images/cards/house.jpg"
              class="align-top"
              :height="chartHeight"
            >
              <v-card-title v-text="chartTitle"></v-card-title>
              <v-card-title v-text="chartSubTitle"></v-card-title>
               <PolarArea 
                    id="Polar-Chart"
                    v-if="chartDataView"
                    :data="chartDataView" 
                    :options="chartOptions"  
                    height="500px"
                    ref="chartView"
                    />
           
            </v-img>


          </v-card>
      </v-col>
      </v-row>
      <v-row  v-if="chartDataView">
        <v-col cols = 5>
        <v-tooltip text="Download chart image">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              icon="mdi-arrow-down-bold-box-outline"
              color="blue-darken-2"
              @click="handleDownload"
            />
          </template>
        </v-tooltip>

        </v-col>
      </v-row>
    </v-container>
  </v-card>

</template>

<script setup>

  import { defineProps, ref, watch, computed } from 'vue'
  //import SOSPolarChart from './SOSPolarChart.vue';

  import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend
  } from 'chart.js';

  import { PolarArea } from 'vue-chartjs';

  ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);


  const props = defineProps({
    chartData: {
      type: Object,
      required: true,
    },
    infoData: {
      type: Object,
      required: true,
    },
    display_indicator_info:{
      type: Object,
      required: false
    }
  });


const showingFullText =  ref(false);
const cache = new Map();
let width = null;
let height = null;

const chartDataView = ref(null);
const chartTitle = ref('');
const chartSubTitle = ref('')
const chartView = ref(null); //the chart image


const chartOptions = ref({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
      //position: 'top',
    },
    title: {
      display: true,
      text: 'Water Functions SOS',
    },
    tooltip: {
      enabled: true, // Keep tooltips enabled if desired
    },
  },

  elements: {
      arc: {
        backgroundColor: function(context) {
          return createRadialGradient3(context);
        },
      },
    },

  scales: {
    r: {
      angleLines: {
        display: false, // Hide angle lines for a cleaner background
      },
      grid: {
        color: 'rgba(200, 200, 200, 0.3)', // Light grid lines
      },
      pointLabels: {
        display: true,
        centerPointLabels: true,
        font: {
          size: 14,
        },
      },
      ticks: {
        display: true,
        beginAtZero: true,
        max: 100, // Crucial for correct gradient mapping
      },
      min: 0, // Explicitly set min to 0
      max: 100, // Explicitly set max to 100
    },
  },

  animation: {
    onComplete: () => {
      updateChartImage()
    },
},



});


const infoHeight = ref(300);
const chartHeight = ref(600);

const indicatorInfoText = computed(() => {

  var trim_text = "";
  var full_text = "";
  if (showingFullText.value){

    full_text = props.display_indicator_info.indicator_description;
    return full_text;
  }
  if (props.display_indicator_info.indicator_description){
    trim_text = props.display_indicator_info.indicator_description.slice(0, 500).trim() + "..." 
  }
  
  return trim_text;

});

const indicatorAdditionalInfoText = computed(() => {

  var info_text = "";
  if (showingFullText.value){

    info_text = "Indicator threshold: " + props.display_indicator_info.indicator_threshold
  }
  
  return info_text;

});

watch(() => showingFullText, (newVal) => {
  
  if(newVal.value == true){
     infoHeight.value = 600;
  }
  else {
    infoHeight.value = 300;
  }

}, { deep: true });


//Watch for changes in polarData prop and update chartData
watch(() => props.chartData, (newVal) => {
  
  chartDataView.value = newVal;
  chartTitle.value = newVal.chart_title;
  chartSubTitle.value = newVal.chart_sub_title;


}, { deep: true });


watch(() => props.infoData, (newVal) => {
  
  indicatorInfoText.value = newVal;

}, { deep: true });



function createRadialGradient3(context) {
  const c1 = "rgba(0, 128, 0, 0.4)";
  const c2 = "rgba(255, 165, 0, 0.4)";
  const c3 = "rgba(255, 0, 0, 0.6)";

  // 1. Determine the stops for this specific arc
  let stops = [0.2, 0.5, 0.6];
  //const stops_map = chartDataView.value.datasets[0].stops_map;

  const stops_map = [ [0.1, 0.2, 0.5],
    [0.1, 0.4, 0.9], // For Arc 0
    [0.2, 0.5, 0.8], // For Arc 1
    [0.3, 0.6, 0.7]  // For Arc 2
];
  
  if (stops_map && stops_map[context.dataIndex]) {
    stops = stops_map[context.dataIndex];
  }

  // 2. Create a UNIQUE cache key including the stops
  // e.g., "0.2,0.5,0.6" or combined with colors if colors were dynamic
  const cacheKey = stops.join(','); 

  const chartArea = context.chart.chartArea;
  if (!chartArea) {
    return;
  }

  const chartWidth = chartArea.right - chartArea.left;
  const chartHeight = chartArea.bottom - chartArea.top;

  // Clear cache if chart resizes
  if (width !== chartWidth || height !== chartHeight) {
    cache.clear();
    width = chartWidth;
    height = chartHeight;
  }

  // 3. Check the cache using the UNIQUE key
  let gradient = cache.get(cacheKey);

  if (!gradient) {
    // Create the gradient
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const r = Math.min(
      (chartArea.right - chartArea.left) / 2,
      (chartArea.bottom - chartArea.top) / 2
    );
    const ctx = context.chart.ctx;
    
    gradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, r);

    gradient.addColorStop(stops[0], c1);
    gradient.addColorStop(stops[1], c2);
    gradient.addColorStop(stops[2], c3);

    // 4. Save to cache with the UNIQUE key
    cache.set(cacheKey, gradient);
  }

  return gradient;
}

  const indicatorTitle = computed(() => props.display_indicator_info.indicator_name + " (" + props.display_indicator_info.indicator_label + ")"
    );
  const indicatorFunction = computed(() => props.display_indicator_info.function_name + " function"
    );

  const handleDownload = () => {
    // The ref directly holds the Chart.js instance.
    const originalChart = chartView.value;

    // Check if the chartRef is a valid object and has a chart instance
    if (!originalChart) {
      console.error('Chart instance not found.');
      return;
    }

    // Create an off-screen canvas element for the high-resolution image
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');

    // The user requested 300x300px and 300 dpi. For a high-quality print,
    // the pixel dimensions should be larger than 300x300px.
    // A standard screen DPI is 96. To get 300 DPI, we need a scale factor.
    // scale = desiredDPI / screenDPI = 300 / 96 ≈ 3.125
    // So, we'll create a canvas 3 times larger for better quality, which
    // is a good approximation for a 300dpi image.
    const desiredWidth = 420;
    const desiredHeight = 600;
    const scaleFactor = 3; 

    // Set the dimensions of the temporary canvas
    tempCanvas.width = desiredWidth * scaleFactor;
    tempCanvas.height = desiredHeight * scaleFactor;
    
    // Draw the original chart content onto the temporary canvas
    // We get the base64 image from the main canvas and draw it scaled
    const originalImage = new Image();
    originalImage.onload = () => {
      // Draw the image onto the temporary canvas
      tempCtx.drawImage(originalImage, 0, 0, tempCanvas.width, tempCanvas.height);
      
      // Get the data URL from the temporary canvas
      const image = tempCanvas.toDataURL('image/png', 1.0);
      
      // Create a link element for the download
      const link = document.createElement('a');
      link.href = image;

      let fname_head = chartTitle.value.replace(' ', '_').toLowerCase();
      fname_head = fname_head.replace('water_function sos', '');
      fname_head = fname_head.replace(' ', '');
      let fname_tail = chartSubTitle.value.replace(' ', '_').toLowerCase();
      fname_tail = fname_tail.replace('.','');
      fname_tail = fname_tail.replace(' ','');
      //link.download = 'chart.png';
      link.download = fname_head + '-'+fname_tail +'.png';
      
      // Append the link to the body and click it to trigger the download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    //originalImage.src = originalChart.toBase64Image();
    //originalImage.src = chartView.value.getChart().toBase64Image()
    originalImage.src = originalChart.chart.toBase64Image()
  };



  const updateChartImage = () => {
    if (chartView.value)  {
        console.log(chartView.value.chart.toBase64Image())
  }
}

// https://vuetifyjs.com/en/components/overlays/#activator
// https://vue-chartjs.org/examples/
// https://stackblitz.com/github/apertureless/vue-chartjs/tree/main/sandboxes/polar-area?file=src%2FchartConfig.ts





  </script>